var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:bag-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 3C18.1934 3 19.3444 3.15234 20.4531 3.45703C21.5618 3.76172 22.5944 4.20182 23.5508 4.77734C24.5072 5.35286 25.3831 6.02995 26.1787 6.80859C26.9743 7.58724 27.6556 8.46322 28.2227 9.43652C28.7897 10.4098 29.2256 11.4466 29.5303 12.5469C29.835 13.6471 29.9915 14.7982 30 16C30 17.1934 29.8477 18.3444 29.543 19.4531C29.2383 20.5618 28.7982 21.5944 28.2227 22.5508C27.6471 23.5072 26.9701 24.3831 26.1914 25.1787C25.4128 25.9743 24.5368 26.6556 23.5635 27.2227C22.5902 27.7897 21.5534 28.2256 20.4531 28.5303C19.3529 28.835 18.2018 28.9915 17 29C15.8066 29 14.6556 28.8477 13.5469 28.543C12.4382 28.2383 11.4056 27.7982 10.4492 27.2227C9.49284 26.6471 8.61686 25.9701 7.82129 25.1914C7.02572 24.4128 6.3444 23.5368 5.77734 22.5635C5.21029 21.5902 4.77441 20.5534 4.46973 19.4531C4.16504 18.3529 4.00846 17.2018 4 16C4 14.8066 4.15234 13.6556 4.45703 12.5469C4.76172 11.4382 5.20182 10.4056 5.77734 9.44922C6.35286 8.49284 7.02995 7.61686 7.80859 6.82129C8.58724 6.02572 9.46322 5.3444 10.4365 4.77734C11.4098 4.21029 12.4466 3.77441 13.5469 3.46973C14.6471 3.16504 15.7982 3.00846 17 3ZM24.6553 11.6963L22.9287 9.96973L14.5625 18.3359L11.0713 14.8447L9.34473 16.5713L14.5625 21.7891L24.6553 11.6963Z",
    fill: "#08B924"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.c245b28b94d6c1496a3923d8ab7eb5cb.svg";
export { ForwardRef as ReactComponent };